<template>
     <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
 <div v-else class="">
            
        <Banner
            :background="(info.image) ? info.image.url: ''"
            :title="(!pgLoading) ? $t('auth.reset_password') : ''"
            :subtitle="(!pgLoading) ? $t('auth.reset_password') : ''">
        </Banner>

 
        <section class="login-area grey-bg2 pt-50">
            <div class="container">
            <div class="row d-flex justify-content-center">
                <div class="login-section donation-form white-bg mb-30 wow fadeInUp2  animated" data-wow-delay=".1s" style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp2;">
                <div  v-if="!pgLoading"  class="section-title text-left mb-50">
                    <h6><span :style="[locale == 'en' ? {'left':'auto'} : {}]"><i class="fas fa-heart"></i></span>{{ info.title }}</h6>
                     <p v-html="info.body" class="reset-desc"></p>
                </div>
                    <div class="row payment-inner">
                        <form >
                            <div class="row">
                                <div class="col-12">
                                    <div class="input-area mb-30">
                                       <input class="form-control" 
                                                type="text" 
                                                v-model="row.token"
                                                :placeholder="$t('auth.token')">
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="input-area mb-30">
                                        <input type="password" class="form-control" 
                                          v-model="row.password"
                                                :placeholder="$t('auth.new_password')">
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="input-area mb-30">
                                        <input type="password" class="form-control" 
                                       v-model="row.password_confirmation"
                                                :placeholder="$t('auth.new_confirm_password')">
                                    </div>
                                </div>

                                <div class="col-xl-12 mb-4">
                                    <button class="theme_btn theme_btn_bg btn-size" 
                                            type="button"
                                            @click="reset()">
                                            <div v-if="btnLoading">
                                                <div class="loader loader-xs loader-center"></div>
                                            </div>
                                            <div v-if="!btnLoading">
                                                {{ $t('auth.update_password') }}
                                                <span></span>
                                            </div>
                                    </button>
                                </div>
                               


                            </div>
                        </form>
                    </div>
                </div>
            </div>
            </div>
        </section>
        
    </div>


</template>

<script>
import iziToast from 'izitoast';

export default {
    name: 'Reset',
    components: {
        Banner: () => import('@/components/Banner.vue'),
    },
    data () {
        return {
            row: {
                token: '',
                email: '',
                password: '',
                password_confirmation: '',
            },
            locale: 'ar',
            btnLoading: false,
            pgLoading: true,
            info: '',
        }
    },
    computed: {},
    created() {
        //

        if(localStorage.getItem('forget_email')) {
            this.row.email = localStorage.getItem('forget_email');
        }
        if(localStorage.getItem('locale')) {
                this.locale = localStorage.getItem('locale');
            }
        this.fetchData();
    },
    methods: {

        // 
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL+'/settings/24',
                method: 'GET',
                data: {},
                params: {
                    locale: this.locale,
                }
            }
            this.$axios(options)
            .then(res => {
                this.pgLoading = false;
                this.info = res.data.info;
            })
            .catch(() => { })
            .finally(() => { });
        },

        // Reset
        reset() {
            this.btnLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL+'/auth/password/reset',
                method: 'POST',
                data: {
                    token: this.row.token,
                    email: this.row.email,
                    password: this.row.password,
                    password_confirmation: this.row.password_confirmation,
                }
            }
            this.$axios(options)
                .then(() => {
                    this.btnLoading = false;
                
                    iziToast.success({
                      icon: 'ti-check',
                      title: '',
                      message: this.$t('app.reset_msg'),
                    });

                    localStorage.removeItem('forget_email');
                    this.$router.push({ name: 'login' });
                })
                .catch(() => {
                    this.btnLoading = false;
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: '',
                        message: this.$t('app.reset_msg_failed'),
                    });
                })
            },

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btn-size { cursor: pointer; width: 232px; height: 52px }
</style>